import React from 'react';
import { Box, Typography, TextField } from '@mui/material';
//import { useTheme } from '@mui/material/styles';

/**
 * Component for displaying and editing the deficiency description
 *
 * @param {Object} props - Component props
 * @param {Object} props.deficiency - Deficiency object containing title and description
 * @param {boolean} props.isEditing - Whether edit mode is active
 * @param {Function} props.onChange - Callback when description data is changed
 * @returns {React.ReactElement} Description section component
 */
const DescriptionSection = ({ deficiency, isEditing, onChange }) => {
    // const theme = useTheme();

    // Extract title and description from deficiency object
    const { title, description } = deficiency || {};

    const handleTitleChange = (event) => {
        if (onChange) {
            onChange({
                title: event.target.value,
                description,
            });
        }
    };

    const handleDescriptionChange = (event) => {
        if (onChange) {
            onChange({
                title,
                description: event.target.value,
            });
        }
    };

    return (
        <>
            {/* Title field - only shown when editing (displayed in header when viewing) */}
            {isEditing && (
                <TextField
                    fullWidth
                    label="Title"
                    value={title || ''}
                    onChange={handleTitleChange}
                    variant="outlined"
                    sx={{
                        mb: 3,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                        },
                    }}
                />
            )}

            <Typography
                variant="caption"
                gutterBottom
                sx={{
                    fontWeight: 600,
                    color: '#666666',
                    fontSize: '0.7rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    mb: 1,
                    display: 'block',
                }}
            >
                Description
            </Typography>

            {isEditing ? (
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Provide a detailed description of the deficiency..."
                    value={description || ''}
                    onChange={handleDescriptionChange}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                        },
                    }}
                />
            ) : (
                <Box
                    sx={{
                        p: 2,
                        backgroundColor: '#F9F9F9',
                        borderRadius: 1.5,
                        border: '1px solid #EBEBEB',
                        minHeight: 60,
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            lineHeight: 1.6,
                            fontSize: '0.875rem',
                            color: description ? '#333333' : '#999999',
                            fontStyle: description ? 'normal' : 'italic',
                        }}
                    >
                        {description || 'No description provided'}
                    </Typography>
                </Box>
            )}
        </>
    );
};

export default DescriptionSection;
